module.exports = __webpack_public_path__ + "img/汉熵数字孪生管理平台.ef71c61b.png";